'use client';

import Image from 'next/image';
import { PortableText } from '@portabletext/react';
import { richTextComponent } from '@/sanity/sanityPortableText';

import HeroPricingCard from './HeroPricingCard';
import HeroPaymentMethods from './HeroPaymentMethods';
import HeroStats from './HeroStats';
import background from '@/public/futures-v2/hero-bg.png';
import { PageFuturesV2Schema } from '@/sanity/pages/PageFuturesV2Template';
import { cn } from '@/lib/utils';

export default function HeroSection({
  data,
  className,
  showTopBanner,
  futures = false,
}: {
  data: PageFuturesV2Schema;
  className?: string;
  showTopBanner?: boolean;
  futures?: boolean;
}) {
  return (
    <section
      className={cn(
        'relative z-0 overflow-x-clip px-[2rem] lg:px-[5rem] pt-[8rem] lg:pt-[5rem]',
        showTopBanner && 'pt-[8rem] lg:pt-[14rem]',
        className,
      )}
    >
      <div
        style={{
          background:
            'linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 100%)',
        }}
        className="absolute bottom-[-5%] h-[40rem] w-full left-0 z-[1]"
      ></div>
      <div className="absolute w-full h-full inset-0 z-0 overflow-clip">
        <Image
          src={background}
          alt="Hero background"
          className="w-full h-full object-cover object-top"
          priority
        />
      </div>
      <div className="relative z-10">
        <div className="container flex relative z-10 flex-col items-center gap-[8.75rem]">
          <div className="w-[min(97.5rem,100%)]  flex flex-col items-center gap-[5.88rem] lg:gap-[4.62rem]">
            <div className="flex flex-col gap-[2rem] text-center items-center">
              {data?.heroChip && (
                <p className="font-medium font-instrument text-black/70 mb-0 text-[1.75rem] lg:text-[2rem]">
                  {data.heroChip}
                </p>
              )}

              {data?.heroText && (
                <div
                  className={cn(
                    'richtext [&_br]:hidden lg:[&_br]:block flex flex-col gap-[2rem] text-center items-center prose-headings:mb-0 prose-headings:font-instrument-sans prose-p:mb-0 lg:prose-p:max-w-[80%]',
                    data?.settings?.slug?.current?.endsWith('/br')
                      ? '[&_br]:block'
                      : '[&_br]:hidden',
                  )}
                >
                  <PortableText
                    value={data.heroText}
                    components={richTextComponent}
                  />
                </div>
              )}
            </div>

            <div className="flex flex-col gap-[5.875rem] items-center">
              <HeroPricingCard data={data} />
              <HeroPaymentMethods
                label={data?.paymentLabel}
                methods={data?.paymentMethods}
              />
            </div>
          </div>

          <HeroStats stats={data?.stats} />
        </div>
      </div>
    </section>
  );
}
